import React, { useEffect, useState } from "react";
import "../../pages/analytics/analytics.css";
import "./uploadModal.css";
import { Dialog, DialogActions, Typography } from "@mui/material";
import CustomButton from "../../reusableComponents/CustomButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import UploadErrorScenarios from "./UploadErrorScenarios";
import { colorBrandObject } from "../../../constants/brandings";

const UploadFileModal = ({
  outlinedBtnText,
  filledBtnText,
  outlinedBtnFunction,
  filledBtnFunction,
  toggleDialog,
  type,
  uploadingFile,
  uploadFileErrors,
  uploadAgain,
}) => {


  const [selectedFile, setSelectedFile] = useState();
  const [fileError, setFileError] = useState();
  const [loadingFile, setLoadingFile] = useState(false);

  const handleOutlinedClicked = () => {
    outlinedBtnFunction();
    setSelectedFile(null);
  };
  const handleFilledClicked = () => {
    if (uploadFileErrors) {
      setSelectedFile(null);
      setLoadingFile(false);
      uploadAgain();
    } else {
      filledBtnFunction(selectedFile);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      outlinedBtnFunction();
      setSelectedFile(null);
    }
  };

  useEffect(() => {
    if (selectedFile) {
      setLoadingFile(false);
    }
  }, [selectedFile]);

  const handleBrowse = (event) => {
    event.preventDefault();

    setLoadingFile(true);
    const file = event?.target?.files[0];
    if (file.name.match(/\.(csv|zip|xls|xlsx)$/i)) {
      setFileError(null);
      const fileSizeInBytes = file.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024;
      if (fileSizeInKilobytes <= 10240) {
        if (file) {
          setSelectedFile(file);
        }
      } else {
        setLoadingFile(false);
        setFileError("Size limit Exceeded : file size is greater than 10MB");
      }
    } else {
      setLoadingFile(false);
      setFileError("invalid format");
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setLoadingFile(true);
    const droppedFile = event?.dataTransfer?.files[0];
    if (droppedFile.name.match(/\.(csv|zip|xls|xlsx)$/i)) {
      setFileError(null);
      const fileSizeInBytes = droppedFile.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024;
      if (fileSizeInKilobytes <= 10240) {
        if (droppedFile) {
          setSelectedFile(droppedFile);
        }
      } else {
        setLoadingFile(false);
        setFileError("Size limit Exceeded : file size is greater than 10MB");
      }
    } else {
      setLoadingFile(false);
      setFileError("invalid format");
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <Dialog
      open={toggleDialog}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
          borderRadius: "12px",
          maxWidth: "640px",
          padding: "32px 32px 25px 32px",
        },
      }}
      onKeyDown={handleKeyDown}
    >
      <div className="upload-modal">
        <div className="upload-modal-header">
          <Typography
            className="headerH1Bold"
            sx={{
              color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
            }}
          >
            Upload file
          </Typography>
          <CloseIcon
            sx={{ height: "24px", width: "24px", cursor: "pointer" }}
            onClick={handleOutlinedClicked}
          />
        </div>
        {!loadingFile &&
          !selectedFile &&
          !uploadingFile &&
          !uploadFileErrors && (
            <div
              className="upload-area"
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              accept=".csv, .zip, .xlsx, .xls"
            >
              <form
                onClick={() => document.querySelector(".upload-field").click()}
              >
                <input
                  type="file"
                  accept=".csv, .zip, .xlsx, .xls"
                  className="upload-field"
                  hidden
                  onChange={handleBrowse}
                />
                <img
                  src="/assets/routingIcons/upload.svg"
                  height={"40px"}
                  width={"40px"}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    marginTop: "16px",
                  }}
                >
                  <Typography
                    className="bodyB1SemiBold"
                    sx={{
                      color:
                        "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                    }}
                  >
                    Upload your file here
                  </Typography>
                  <Typography
                    className="bodyB2RegularText"
                    sx={{
                      color: "var(--character-title-85, rgba(0, 0, 0, 0.85))",
                    }}
                  >
                    Drag & drop file or{" "}
                    <span
                      style={{
                        color: `${colorBrandObject?.primaryButtonColor}`,
                        // color: "var(--Generic-Primary-accent, #403E9F)",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "18px",
                      }}
                    >
                      Browse from computer
                    </span>
                  </Typography>
                  <Typography
                    className="labelRegular"
                    sx={{
                      color:
                        "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                    }}
                  >
                    File Size: (Max 10MB)
                  </Typography>
                  {fileError && (
                    <div className="error">
                      <img src="/assets/errorOutline.svg" />
                      <Typography
                        className="labelRegular"
                        style={{
                          color: "var(--comms-negative, #B9232F)",
                          padding: "2px 0px 6px 0px",
                        }}
                      >
                        {fileError}
                      </Typography>
                    </div>
                  )}
                </div>
              </form>
            </div>
          )}
        {!selectedFile && loadingFile && !uploadFileErrors ? (
          <div className="error-area" style={{ gap: "16px" }}>
            <CircularProgress
              sx={{
                height: "40px",
                width: "40px",
              }}
            />
            <Typography
              className="bodyB2RegularText"
              sx={{
                color: "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
              }}
            >
              Loading file ...
            </Typography>
          </div>
        ) : (
          selectedFile &&
          !loadingFile &&
          !uploadingFile &&
          !uploadFileErrors && (
            <div className="error-area" style={{ gap: "16px" }}>
              <InsertDriveFileOutlinedIcon
                sx={{
                  height: "40px",
                  width: "40px",
                  color: "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                }}
              />
              <Typography
                className="bodyB1SemiBold"
                sx={{
                  color: "var(--Text-Medium, rgba(1, 1, 2, 0.60)) !important",
                }}
              >
                {selectedFile?.name}
              </Typography>
            </div>
          )
        )}
        {uploadingFile && !uploadFileErrors && (
          <div className="error-area" style={{ gap: "16px" }}>
            <CircularProgress
              sx={{
                height: "40px",
                width: "40px",
              }}
            />
            <Typography
              className="bodyB2RegularText"
              sx={{
                color: "rgba(79, 77, 85, 1)",
              }}
            >
              Please wait your file is uploading
            </Typography>
          </div>
        )}
        {uploadFileErrors && (
          <div className="error-area" style={{ gap: "8px" }}>
            <UploadErrorScenarios uploadFileErrors={uploadFileErrors} />
          </div>
        )}
      </div>

      <DialogActions
        className="upload-modal-footer"
        sx={{ border: "0px", display: "flex" }}
      >
        {outlinedBtnText != "" && (
          <CustomButton
            text={outlinedBtnText}
            variant={"outlined"}
            type={type}
            size={"md"}
            onClick={handleOutlinedClicked}
          />
        )}
        {filledBtnText != "" && (
          <CustomButton
            text={uploadFileErrors ? "Upload again" : filledBtnText}
            disabled={!selectedFile}
            variant={"contained"}
            type={type}
            size={"md"}
            onClick={handleFilledClicked}
          />
        )}
      </DialogActions>
    </Dialog>
  );
};

UploadFileModal.defaultProps = {
  outlinedBtnText: "",
  filledBtnText: "",
  outlinedBtnFunction: () => { },
  filledBtnFunction: () => { },
  toggleDialog: false,
  type: "primary",
};

export default UploadFileModal;
